import { generateMetricKey } from '@intelligence/v3/utils/metric';
import { DATASOURCE_KEY_MAP, GSD_METRIC_KEY_MAP } from './keyMap';

/**
 * GSD数据源Total Revenue指标
 */
export const GSD_TOTAL_REVENUE_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.TOTAL_REVENUE,
});

/**
 * GSD数据源Total Revenue指标环比
 */
export const GSD_TOTAL_REVENUE_METRIC_RATIO_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.TOTAL_REVENUE,
  ratio: true,
});

/**
 * GSD数据源Digital Revenue指标
 */
export const GSD_DIGITAL_REVENUE_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.DIGITAL_REVENUE,
});

/**
 * GSD数据源Digital Revenue指标环比
 */
export const GSD_DIGITAL_REVENUE_METRIC_RATIO_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.DIGITAL_REVENUE,
  ratio: true,
});

/**
 * GSD数据源Physical Revenue指标
 */
export const GSD_PHYSICAL_REVENUE_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.PHYSICAL_REVENUE,
});

/**
 * GSD数据源Physical Revenue指标环比
 */
export const GSD_PHYSICAL_REVENUE_METRIC_RATIO_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.PHYSICAL_REVENUE,
  ratio: true,
});

/**
 * GSD数据源Total Units指标
 */
export const GSD_TOTAL_UNITS_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.TOTAL_UNITS,
});

/**
 * GSD数据源Total Units指标环比
 */
export const GSD_TOTAL_UNITS_METRIC_RATIO_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.TOTAL_UNITS,
  ratio: true,
});

/**
 * GSD数据源Digital Units指标
 */
export const GSD_DIGITAL_UNITS_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.DIGITAL_UNITS,
});

/**
 * GSD数据源Digital Units指标环比
 */
export const GSD_DIGITAL_UNITS_METRIC_RATIO_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.DIGITAL_UNITS,
  ratio: true,
});

/**
 * GSD数据源Physical Units指标
 */
export const GSD_PHYSICAL_UNITS_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.PHYSICAL_UNITS,
});

/**
 * GSD数据源Physical Units指标环比
 */
export const GSD_PHYSICAL_UNITS_METRIC_RATIO_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.GSD,
  metric: GSD_METRIC_KEY_MAP.PHYSICAL_UNITS,
  ratio: true,
});
